import * as React from 'react';

export interface QueryFilterIconProps {
    member: string;
    filterable: boolean;
    filtered: boolean;
    onFilter: (member: string, event: any) => void;
    automationid?: string;
}

export const QueryFilterIcon = (props: QueryFilterIconProps) => {
    const { member, filterable, filtered, onFilter } = props;
    const handleFilter = _event => onFilter(member, onFilter);

    if (filtered) {
        return (
            <a onClick={handleFilter}>
                <i
                    data-automationid={props.automationid}
                    style={{ paddingLeft: "8px" }}
                    className="fa fa-filter text-info"
                    aria-hidden="true"
                />
            </a>
        );
    }
    if (filterable) {
        return (
            <a onClick={handleFilter} data-automationid={props.automationid}>
                <i style={{ paddingLeft: "8px" }} className="fa fa-filter" aria-hidden="true" />
            </a>
        );
    }

    return null;
};
